<template>
    <b-tabs conten-class="mt-2">
      <b-tab title="Offer Details" active>
        <div class="offer-item">
          <b-card no-body class="mx-6">
            <b-card-body class="p-6">
              <b-form>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      id="fieldsetOfferName"
                      :label-cols="3"
                      breakpoint="md"
                      label="Offer Name*:"
                      label-for="inputOfferName"
                    >
                      <b-form-input
                        id="inputOfferName"
                        v-model="copayOfferName"
                        debounce="500"
                        name="inputOfferName"
                        v-validate="'required'"
                        data-vv-as="Offer Name"
                        :class="{'input': true, 'text-danger': errors.has('inputOfferName') }"
                        placeholder="Offer Name"
                        :disabled="isReadonly"
                      ></b-form-input>
                      <span class="text-danger">{{ errors.first('inputOfferName') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      id="fieldsetManufacture"
                      :label-cols="3"
                      breakpoint="md"
                      label="Manufacturer*:"
                      label-for="inputManufacture"
                    >
                      <b-form-input
                        id="inputManufacture"
                        name="inputManufacture"
                        debounce="500"
                        v-model="manufacture"
                        v-validate="'required'"
                        data-vv-as="Manufacturer"
                        :class="{'input': true, 'text-danger': errors.has('inputManufacture') }"
                        type="text"
                        placeholder="Manufacturer"
                        :disabled="isReadonly"
                      ></b-form-input>
                      <span class="text-danger">{{ errors.first('inputManufacture') }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      id="fieldsetIsPendingInactive"
                      :label-cols="3"
                      breakpoint="md"
                      label="Disabled:"
                      label-for="radio-pending-inactivate"
                    >
                      <b-form-radio-group
                        id="radio-pending-inactivate"
                        v-model="isPendingInactivation"
                        name="radio-pending-inactivate"
                      >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                      </b-form-radio-group>
                      <small class="text-muted" v-show="isPendingInactivation === true">
                        The offer is turned off.
                      </small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      id="fieldsetDrugName"
                      :label-cols="3"
                      breakpoint="md"
                      label="Drug Name*:"
                      label-for="inputDrugName"
                    >
                      <b-form-input
                        id="inputDrugName"
                        name="inputDrugName"
                        v-model="drugName"
                        debounce="500"
                        v-validate="'required'"
                        data-vv-as="Drug Name"
                        :class="{'input': true, 'text-danger': errors.has('inputDrugName') }"
                        type="text"
                        placeholder="Drug Name"
                        :disabled="isReadonly"
                      ></b-form-input>
                      <span class="text-danger">{{ errors.first('inputDrugName') }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      id="fieldsetActivationDateRange"
                      :label-cols="3"
                      breakpoint="md"
                      label="Active Dates*:"
                      label-for="inputActivationDateRange"
                    >
                      <span>Input 1/1/2099 for no end date</span>
                      <date-picker
                        name="inputActivationDateRange"
                        v-model="activationDateRange"
                        debounce="500"
                        v-validate="'required'"
                        data-vv-as="Active Dates"
                        :class="{'input': true, 'text-danger': errors.has('inputActivationDateRange') }"
                        class="form-control"
                        type="date"
                        :not-before="new Date()"
                        lang="en"
                        range
                        format="YYYY-MM-DD"
                        range-separator="thru"
                        :shortcuts="shortcuts"
                        confirm
                        :disabled="isReadonly"
                      ></date-picker>
                      <span class="text-danger">{{ errors.first('inputActivationDateRange') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-row v-if="offer">
                      <b-col>
                        <b-form-group
                          id="fieldsetGlobalProductListId"
                          :label-cols="3"
                          breakpoint="md"
                          label="Include NDCs from Global Product List:"
                          label-for="selectGlobalProductListId"
                        >
                          <b-form-select
                            v-model="globalProductListId"
                            :options="globalProductLists"
                            id="selectGlobalProductListId"
                            class="mb-3"
                            :disabled="isReadonly"
                            v-if="!isLoadingGlobalProductLists"
                          />

                          <b-form-select
                            v-if="isLoadingGlobalProductLists"
                            value=""
                            :options="[{value: '', text: 'Loading Global Product Lists...'}]"
                            :disabled="true"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="offer">
                      <b-col>
                        <b-form-group
                          id="fieldsetGlobalListId"
                          :label-cols="3"
                          breakpoint="md"
                          label="Include NPIs from Global List:"
                          label-for="selectGlobalListId"
                        >
                          <b-form-select
                            v-model="globalListId"
                            :options="globalLists"
                            id="selectGlobalListId"
                            class="mb-3"
                            :disabled="isReadonly"
                            v-if="!isLoadingGlobalLists"
                          />

                          <b-form-select
                            v-if="isLoadingGlobalLists"
                            value=""
                            :options="[{value: '', text: 'Loading Global Lists...'}]"
                            :disabled="true"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- New: Multi-select for Portal IDs -->
                    <b-row v-if="offer">
                      <b-col>
                        <b-form-group
                          id="fieldsetPortalIds"
                          :label-cols="3"
                          breakpoint="md"
                          label="Select Portals:"
                          label-for="selectPortalIds"
                        >
                        <b-form-select
                          v-model="portalIds"
                          :options="isLoadingPortalLists ? [{ value: '', text: 'Loading Portals...' }] : portalLists"
                          id="selectPortalIds"
                          class="mb-3"
                          :disabled="isReadonly || isLoadingPortalLists"
                          multiple
                        />
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="offer && offer.ndc_num">
                      <b-col>
                        <VItemList
                          listLabel="Matching NDCs*:"
                          itemValidation="digits:11"
                          itemValidationName="NDC"
                          itemPlaceholder="Enter 11 digit NDC"
                          :items="offer.ndc_num ? offer.ndc_num : []"
                          @add="addNDC"
                          @remove="removeNDC"
                          :isReadonly="isReadonly"
                        ></VItemList>
                      </b-col>
                    </b-row>

                    <b-row v-if="offer">
                      <b-col>
                        <VItemList
                          listLabel="Prescriber State Exclusions:"
                          :itemValidation="`alpha|length:2|included:${Object.keys(states).join()}`"
                          itemValidationName="State code"
                          itemPlaceholder="Enter 2 letter State Code"
                          itemValidationMessage="Prescriber State Exclusion must contain a 2 character valid state code."
                          :items="offer.state_exclusion_list_array ? offer.state_exclusion_list_array : []"
                          @add="addStateCode"
                          @remove="removeStateCode"
                          :isReadonly="isReadonly"
                        ></VItemList>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <span>Age Limits:</span>
                        <b-form-group
                          id="fieldsetOfferMinimumAge"
                          :label-cols="3"
                          breakpoint="md"
                          label="Greater than or equal to*:"
                          label-for="inputOfferMinimumAge"
                        >
                          <b-form-input
                            v-model="offerMinimumAge"
                            debounce="500"
                            name="inputOfferMinimumAge"
                            v-validate="'required'"
                            data-vv-as="Minimum Age"
                            :class="{'input': true, 'text-danger': errors.has('inputOfferMinimumAge') }"
                            placeholder=""
                            :disabled="isReadonly"
                          ></b-form-input>
                          <span class="text-danger">{{ errors.first('inputOfferMinimumAge') }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          id="fieldsetOfferMaximumAge"
                          :label-cols="3"
                          breakpoint="md"
                          label="Less than or equal to*:"
                          label-for="inputOfferMaximumAge"
                        >
                          <b-form-input
                            v-model="offerMaximumAge"
                            debounce="500"
                            name="inputOfferMaximumAge"
                            v-validate="'required'"
                            data-vv-as="Maximum Age"
                            :class="{'input': true, 'text-danger': errors.has('inputOfferMaximumAge') }"
                            placeholder=""
                            :disabled="isReadonly"
                          ></b-form-input>
                          <span class="text-danger">{{ errors.first('inputOfferMaximumAge') }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          id="fieldsetProgramId"
                          :label-cols="3"
                          breakpoint="md"
                          label="ScriptGuide Patient Offer Program ID:"
                          label-for="inputProgramId"
                        >
                          <b-form-input
                            v-model="offerProgramId"
                            debounce="500"
                            name="inputProgramId"
                            data-vv-as="Program Id"
                            :class="{'input': true, 'text-danger': errors.has('inputProgramId') }"
                            placeholder=""
                            :disabled="isReadonly"
                          ></b-form-input>
                          <span class="text-danger">{{ errors.first('inputProgramId') }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          id="fieldsetComments"
                          :label-cols="3"
                          breakpoint="md"
                          label="Comments:"
                          label-for="inputComments"
                        >
                          <b-form-textarea
                            id="inputComments"
                            v-model="offerComments"
                            debounce="500"
                            rows="3"
                            max-rows="6"
                            name="inputComments"
                            data-vv-as="Comments"
                            :disabled="isReadonly"
                          ></b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col>
                    <b-form-group
                      id="fieldsetSegments"
                      :label-cols="3"
                      breakpoint="md"
                      label="Segments*:"
                      label-for="listSegments"
                    >
                      <b-row v-if="offer && offer.segments">
                        <b-col>
                          <VOfferSegmentList
                            :segments="offer.segments"
                            :offerType="offer.offer_type_text"
                            @copy="copySegment"
                            @edit="editSegment"
                            @remove="removeSegment"
                            :isReadonly="isReadonly"
                          ></VOfferSegmentList>
                        </b-col>
                        <b-col class="segment-add" cols="1" row v-if="!isReadonly">
                          <a @click="addSegment">
                            <i class="fa fa-plus-circle"></i>
                          </a>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="1" sm="2" offset="10" offset-sm="8">
                    <b-button variant="secondary" block @click="clear()">Cancel</b-button>
                  </b-col>
                  <b-col cols="1" sm="2">
                    <b-button :disabled="isReadonly" variant="primary" block @click="save()">Save</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
          <b-modal ref="segmentItemModalRef" size="lg" @ok="saveSegment" title="Segment">
            <VOfferSegmentItem
              ref="segmentItemRef"
              :segment="selectedSegment"
              :states="states"
              :offerType="offer.offer_type_text ? offer.offer_type_text : ''"
              :isReadonly="isReadonly"
            ></VOfferSegmentItem>
          </b-modal>
        </div>
      </b-tab>
      <b-tab title="Change Logs">
        <b-row>
          <b-col sm="3" md="4" class="my-1">
            <b-form-group
              label="Filter"
              label-for="filter-input"
              label-cols-sm="2"
              label-align-sm="left"
              label-size="sm"
              class="mb-0">
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filterHistories"
                  type="search"
                  placeholder="Type to Search">
                </b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filterHistories" @click="filterHistories = ''">Clear</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button size="sm" :disabled="!this.$route.params.copay_offer_id" @click="reloadOffer()">Reload</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <div class="changeHistories">
              <b-table striped hover small show-empty
                       :items="changeHistories"
                       :fields="changeHistoryFields"
                       :current-page="currentPage"
                       :per-page="perPage"
                       :filter="filterHistories"
                       :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc"
                       :sort-direction="sortDirection"
                       @filtered="onFiltered">
              </b-table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="2" md="2" class="my-1">
            <b-form-group
              v-if="totalRows > 0"
              label="Rows"
              label-for="per-page-select"
              label-cols-sm="3"
              label-cols-md="3"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0">
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="2" md="2" class="my-1">
            <b-pagination
              v-if="totalRows > 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0">
            </b-pagination>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

</template>

<script>
// @ts-check
import DatePicker from "vue2-datepicker";
import router from "@/router";
import { mapGetters, mapState } from "vuex";
import VOfferSegmentItem from "@/components/VOfferSegmentItem";
import VOfferSegmentList from "@/components/VOfferSegmentList";
import VItemList from "@/components/VItemList";
import moment from 'moment';
import {
  OFFER_CREATE,
  OFFER_ADD,
  OFFER_SAVE,
  OFFER_GET,
  OFFER_ADD_NDC,
  OFFER_REMOVE_NDC,
  OFFER_ADD_STATE_EXCLUSION,
  OFFER_REMOVE_STATE_EXCLUSION,
  OFFER_SAVE_SEGMENT,
  OFFER_ADD_SEGMENT,
  OFFER_REMOVE_SEGMENT,
  OFFER_LOAD_GLOBAL_PRODUCT_LISTS,
  OFFER_LOAD_GLOBAL_LISTS,
  OFFER_LOAD_PORTAL_LISTS
} from "@/store/offer/actions.type";
import {
  SET_OFFER_NAME,
  SET_OFFER_DRUG_NAME,
  SET_OFFER_GLOBAL_PRODUCT_LIST_ID,
  SET_OFFER_GLOBAL_LIST_ID,
  SET_OFFER_IS_PENDING_INACTIVATION,
  SET_OFFER_EFFECTIVE_DATE,
  SET_OFFER_END_DATE,
  SET_OFFER_MANUFACTURE,
  SET_OFFER_MINIMUM_AGE,
  SET_OFFER_MAXIMUM_AGE,
  SET_OFFER_PROGRAM_ID,
  SET_OFFER_COMMENTS
} from "@/store/offer/mutations.type";

export default {
  name: "OfferItem",
  components: {
    DatePicker,
    VOfferSegmentItem,
    VOfferSegmentList,
    VItemList
  },
  data() {
    return {
      shortcuts: [],
      ndcToAdd: null,
      selectedRange: [getStartDate(), getEndDate()],
      selectedSegment: {},
      isReadonly: false,
      changeHistoryFields: [
        { key: 'field_name', label: 'Field Name', sortable: true },
        {
          key: 'old_value',
          label: 'Old Value',
          sortable: true,
          formatter: (value, key, item) => {
            if (item.field_name === 'OfferEffectiveDate' || item.field_name === 'OfferEndDate') {
              let dateFormat = 'YYYY-MM-DD';
              let isValid = moment(value, dateFormat).isValid();
              if (isValid) {
                return moment(value).format('YYYY-MM-DD');
              }
            }

            return value === '(null)' ? '' : value;
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'new_value',
          label: 'New Value',
          sortable: true,
          formatter: (value, key, item) => {
            if (item.field_name === 'OfferEffectiveDate' || item.field_name === 'OfferEndDate') {
              let dateFormat = 'YYYY-MM-DD';
              let isValid = moment(value, dateFormat).isValid();
              if (isValid) {
                return moment(value).format('YYYY-MM-DD');
              }
            }

            return value === '(null)' ? '' : value;
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        { key: 'username', label: 'Username', sortable: true },
        {
          key: 'modified_date_time',
          label: 'Changed Date/Time',
          sortable: true,
          sortDirection: 'desc',
          formatter: (value) => {
            return moment(value).format("YYYY-MM-DD HH:mm:ss");
          },
          sortByFormatted: true,
          filterByFormatted: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, { value: 1000, text: "Show All" }],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterHistories: null,
      totalfilteredHistories: 0
    };
  },
  computed: {
    ...mapGetters({
      offer: "currentOffer",
      groups: "groups"
    }),
    ...mapState({
      states: state => state.offer.states,
      isLoadingGlobalProductLists: state => state.offer.isLoadingGlobalProductLists,
      globalProductLists: state => state.offer.globalProductLists,
      isLoadingGlobalLists: state => state.offer.isLoadingGlobalLists,
      globalLists: state => state.offer.globalLists,
      isLoadingPortalLists: state => state.offer.isLoadingPortalLists,
      portalLists: state => state.offer.portalLists
    }),
    portalIds: {
      get() {
        return this.$store.getters.currentOffer && this.$store.getters.currentOffer.portal_ids || [];
      },
      set(value) {
        const finalValue = (!value || value.length === 0) ? [0] : value;
        this.$store.getters.currentOffer.portal_ids = finalValue;
      }
    },
    manufacture: {
      get() {
        return this.$store.getters.currentOffer.manufacture_name;
      },
      set(value) {
        this.$store.commit(SET_OFFER_MANUFACTURE, value);
      }
    },
    copayOfferName: {
      get() {
        return this.$store.getters.currentOffer.copay_offer_name;
      },
      set(value) {
        this.$store.commit(SET_OFFER_NAME, value);
      }
    },
    drugName: {
      get() {
        return this.$store.getters.currentOffer.drug_name;
      },
      set(value) {
        this.$store.commit(SET_OFFER_DRUG_NAME, value);
      }
    },
    globalProductListId: {
      get() {
        return this.$store.getters.currentOffer && this.$store.getters.currentOffer.global_product_list_id !== undefined ? this.$store.getters.currentOffer.global_product_list_id : 0;
      },
      set(value) {
        this.$store.commit(SET_OFFER_GLOBAL_PRODUCT_LIST_ID, value);
      }
    },
    globalListId: {
      get() {
        return this.$store.getters.currentOffer && this.$store.getters.currentOffer.global_list_id !== undefined ? this.$store.getters.currentOffer.global_list_id : 0;
      },
      set(value) {
        this.$store.commit(SET_OFFER_GLOBAL_LIST_ID, value);
      }
    },
    isPendingInactivation: {
      get() {
        return this.$store.getters.currentOffer.is_pending_inactivation;
      },
      set(value) {
        this.$store.commit(SET_OFFER_IS_PENDING_INACTIVATION, value);
      }
    },
    activationDateRange: {
      get() {
        const startDate = this.$store.getters.currentOffer.offer_effective_date;
        const endDate = this.$store.getters.currentOffer.offer_end_date;
        return [startDate, endDate];
      },
      set(value) {
        this.$store.commit(SET_OFFER_EFFECTIVE_DATE, value[0]);
        this.$store.commit(SET_OFFER_END_DATE, value[1]);
      }
    },
    offerMinimumAge: {
      get() {
        // Return an empty string when this is a new offer
        if (this.$store.getters.currentOffer.copay_offer_id === undefined && this.$store.getters.currentOffer.offer_minimum_age_num === 0) {
          return "";
        } else {
          return this.$store.getters.currentOffer.offer_minimum_age_num;
        }
      },
      set(value) {
        if (Number.isInteger(value)) {
          this.$store.commit(SET_OFFER_MINIMUM_AGE, Number(value));
        } else {
          this.$store.commit(SET_OFFER_MINIMUM_AGE, value);
        }
      }
    },
    offerMaximumAge: {
      get() {
        return this.$store.getters.currentOffer.offer_maximum_age_num;
      },
      set(value) {
        if (Number.isInteger(value)) {
          this.$store.commit(SET_OFFER_MAXIMUM_AGE, Number(value));
        } else {
          this.$store.commit(SET_OFFER_MAXIMUM_AGE, value);
        }
      }
    },
    offerProgramId: {
      get() {
        return this.$store.getters.currentOffer.program_id;
      },
      set(value) {
        this.$store.commit(SET_OFFER_PROGRAM_ID, value);
      }
    },
    offerComments: {
      get() {
        return this.$store.getters.currentOffer.offer_note_change_text;
      },
      set(value) {
        this.$store.commit(SET_OFFER_COMMENTS, value);
      }
    },
    userName: {
      get() {
        return this.$store.state.auth.profile["cognito:username"];
      }
    },
    changeHistories: {
      get() {
        return this.$store.getters.currentOffer.changeHistories;
      }
    },
    totalChangeHistories() {
      let totalRows = 0;
      if (this.$route.params.copay_offer_id) {
        let logEntries = this.$store.getters.currentOffer.changeHistories;
        if (logEntries) {
          totalRows = logEntries.reduce((sum, a) => sum + 1, 0);
        } else {
          totalRows = 0;
        }
      }

      return totalRows;
    }
  },
  mounted(){
    // Set the initial number of items
    if (this.totalfilteredHistories) {
      this.totalRows = this.totalfilteredHistories;
    } else {
      this.totalRows = this.totalChangeHistories;
    }

    this.currentPage = 1;
  },
  beforeUpdate() {
    if (this.totalfilteredHistories > 0) {
      this.totalRows = this.totalfilteredHistories;
    } else {
      this.totalRows = this.totalChangeHistories;
    }
  },
  methods: {
    async save(evt) {
      if (this.isReadonly) {
        return;
      }

      await this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          return;
        }

        // Handle portal_ids: if "All" is selected, save as [0] instead of empty array
        if (this.portalIds && this.portalIds.length === 0) {
          this.offer.portal_ids = [0];
        }

        // Remove change histories before saving
        delete this.offer.changeHistories;

        // Add Username to the offer object
        this.offer.username = this.userName;

        if (this.offer.copay_offer_id) {
          this.$store.dispatch(OFFER_SAVE, this.offer).then(result => {
            if (result) router.go(-1);
          });
        } else {
          this.$store.dispatch(OFFER_ADD, this.offer).then(result => {
            if (result) router.go(-1);
          });
        }
      });
    },
    clear() {
      router.go(-1);
    },
    addStateCode(stateCode) {
      if (stateCode) {
        this.$store.dispatch(OFFER_ADD_STATE_EXCLUSION, stateCode);
      }
    },
    removeStateCode(stateCode) {
      this.$store.dispatch(OFFER_REMOVE_STATE_EXCLUSION, stateCode);
    },
    addNDC(value) {
      if (value) {
        this.$store.dispatch(OFFER_ADD_NDC, value);
      }
    },
    removeNDC(ndc) {
      this.$store.dispatch(OFFER_REMOVE_NDC, ndc);
    },
    addSegment() {
      this.selectedSegment = { use_when_patient_pay_not_set: false };
      this.$refs.segmentItemModalRef.show();
    },
    copySegment(segment) {
      let createSegment = {...segment};
      createSegment.segment_id = null;
      this.selectedSegment = { ...createSegment };
      this.$refs.segmentItemModalRef.show();
    },
    editSegment(segment) {
      this.selectedSegment = { ...segment };
      this.$refs.segmentItemModalRef.show();
    },
    async saveSegment(evt) {
      evt.preventDefault();
      await this.$refs.segmentItemRef.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this.$refs.segmentItemRef.$validator.reset();
        if (this.selectedSegment.segment_id) {
          this.$store
            .dispatch(OFFER_SAVE_SEGMENT, this.selectedSegment)
            .then(result => {
              this.$refs.segmentItemModalRef.hide();
            });
        } else {
          this.$store
            .dispatch(OFFER_ADD_SEGMENT, this.selectedSegment)
            .then(result => {
              this.$refs.segmentItemModalRef.hide();
            });
        }
      });
    },
    removeSegment(segment) {
      this.$store.dispatch(OFFER_REMOVE_SEGMENT, segment);
    },
    reloadOffer() {
      if (this.$route.params.copay_offer_id) {
        this.$store.dispatch(OFFER_GET, {
          copay_offer_id: this.$route.params.copay_offer_id,
          viewActive: this.$route.params.viewActive
        });
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.totalfilteredHistories = this.totalRows;
    }
  },
  created() {
    if (this.$route.params.copay_offer_id) {
      if (this.$route.params.viewActive) {
        this.isReadonly = true;
      } else if (this.$route.params.offer_status_text === "pending_approval") {
        this.isReadonly = true;
      } else {
        this.isReadonly =
          this.$store.getters.groups.indexOf("RTPSDataAdmin") === -1;
      }

      this.$store.dispatch(OFFER_GET, {
        copay_offer_id: this.$route.params.copay_offer_id,
        viewActive: this.$route.params.viewActive
      });
    } else if (this.$route.params.offer_type_text) {
      this.$store.dispatch(OFFER_CREATE, {
        offer_type_text: this.$route.params.offer_type_text
      });
    }

    this.$store.dispatch(OFFER_LOAD_GLOBAL_PRODUCT_LISTS);
    this.$store.dispatch(OFFER_LOAD_GLOBAL_LISTS);
    this.$store.dispatch(OFFER_LOAD_PORTAL_LISTS);
  }
};

function getStartDate() {
  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);
  startDate.setHours(0, 0, 0, 0);
  return startDate;
}

function getEndDate() {
  let endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  return endDate;
}
</script>
<style>
.offer-item {
  min-height: 500px;
}
.segment-card {
  margin-bottom: 10px;
}
.segment-card .card-body {
  padding: 10px;
}
.list-group-item input {
  border-width: 0;
}

.segment-add {
  padding-left: 0;
}
.segment-add i {
  padding-top: 12px;
  padding-bottom: 10px;
}

.segment-edit.col-3 i {
  padding-left: 5px;
  padding-right: 5px;
}

.offer-status {
  padding: 7px;
  font-size: 14px;
  font-weight: bold;
}
.text-danger {
  border-color: red;
}
span.text-danger {
  color: red;
}
#radio-pending-inactivate {
  margin-left: 25px;
}

.changeHistories td {
  word-break: break-all;
}

#selectPortalIds {
  height: 176px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/OfferItem.vue